import '../assets/css/bootstrap.css';
import '../assets/icons/font-awesome/css/font-awesome.css';
import '../assets/css/main.css';
import brFlag from "../assets/images/br.jpg";
import esFlag from "../assets/images/es.jpg";

import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate, useParams,useSearchParams } from "react-router-dom";
import { Autocomplete, TextField } from '@mui/material';
import HeaderFormulario from "../components/HeaderFormulario";
import styled, { ThemeContext } from "styled-components";
import { FormProvider, set, useForm, useFormContext } from "react-hook-form";
import { getCidades, getEstados, getLayoutModelo, getVeiculos, postGarantia, putGarantia, getNumeroSerie } from "../services/api";
import { InputForm } from "../components/InputForm";
import InputMask from "react-input-mask";
import { isEditable, isEditableInput } from '@testing-library/user-event/dist/utils';
import clarioslogo from "../assets/images/clarios-logo.png"
import { getApiResources,getResource,setLanguage,getLanguage } from "../utils/language";
export const Fomulario = () => {
  const [codigo, setCodigo] = useState<number>(0);
  const [isErroGrave, setErroGrave] = useState<boolean>(false);
  const [getAux, setAux] = useState<string>("");
  const { id } = useParams<string>(); 
  const methods = useForm({ mode: "onBlur" });
  const [maskTelefone, setMaskTelefone] = useState("(99) 99999-9999");
  const { register, handleSubmit, watch, formState: { errors }, setError, clearErrors, setValue, getValues } = methods;
  const navigate = useNavigate();
  const [selectedCidade, setSelectedCidade] = useState<string>("");
  const [estados, setEstados] = useState<{ Uf: string }[]>([]);
  const [cidades, setCidades] = useState<{ Municipio: string, Uf: string }[]>([]);
  const [veiculos, setVeiculos] = useState<string[]>([]);
  const [config, setConfig] = useState<{ Logo: string, Cor: string, Modelo: string }>();
  const [isSuccess, setSuccess] = useState<boolean>(false);
  const [isError, setErrorForm] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);
  const urlPrivacidade = "/politica-de-privacidade" + (id ? "/" + id : "");
  const [dataAtual, setDataAtual] = useState(new Date());
  const [dataFabrticacao, setDataFabrticacao] = useState<string>("");
  const [isSemIdentidade, setIsSemIdentidade] = useState<boolean>(false) 
  const [isSemnumeroSerie, setIsSemnumeroSerie] = useState<boolean>(false) 
  const [isModeloPreenchido, setIsModeloPreenchido] = useState<boolean>(false) 
  const [isNumeroSeriePreenchido, setIsNumeroSeriePreenchido] = useState<boolean>(false) 
  const [isVeiculoOutros, setisVeiculoOutros] = useState<boolean>(false) 
  const [idioma, setIdioma] = useState(getLanguage());
  const [isSubstituicao, setIsSubstituicao] = useState<boolean>(false) 
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const salvarGarantia = (data: any) => {
    setIsLoading(true);
    data.Idioma = getLanguage();
    if (codigo > 0) {
      putGarantia(data).then((res: any) => {
       
        if (ref.current) {
          const offsetBottom = ref.current.offsetTop;
          window.scrollTo({ top: offsetBottom });
        }
        if (res.sucesso == true) {
          setSuccess(true);
          setErrorForm("");
          setTimeout(() => {
            navigate("/certificado/" + res.codigo);
          }, 2000);

        } else {
          setSuccess(false);
          //setErrorForm(res.erro);
          setErrorForm(getResource(res.chaveerro));
          setIsLoading(false);
        }
      });
    }
    else {
      postGarantia(data).then((res: any) => {
        if (ref.current) {
          const offsetBottom = ref.current.offsetTop;
          window.scrollTo({ top: offsetBottom });
        }
        if (res.sucesso == true) {
          setSuccess(true);
          setErrorForm("");
          setTimeout(() => {
            navigate("/certificado/" + res.codigo);
          }, 2000);

        } else {
          setSuccess(false);
          //setErrorForm(res.erro);
          setErrorForm(getResource(res.chaveerro));
          setIsLoading(false);
        }
      });
    }
  }

  const handleChangeEstado = (event: any) => {
    let params = "";
    var uf = event.target.value
    if (uf != "") {
      params += "uf=" + uf + "&";
      getCidades(params).then((res: any) => {
        setCidades(res);
      });
    } else {
      setCidades([]);
    }
    setSelectedCidade("");
  };

  useEffect(() => {
    getApiResources();
    var params = "";
    if (id) {
      setValue("SerieBateria", id);
      setIsNumeroSeriePreenchido(true);
      params = "numeroSerie=" + id;
    }
    if (token) {      
      params += "&tokenAutorizacao=" + token;
    }

    setDataAtual(date => {
      date.setDate(date.getDate());
      return new Date(date);
    });

    /*getEstados().then((res: any) => {
      setEstados(res);
    });*/
    
    getLayoutModelo(params).then((res: any) => {
      setValue("ModeloBateria", res.Modelo);

      if(res.Cor === null && res.Logo === null && res.Marca === null) {
        setIsSemIdentidade(true)
        //document.title = res?.Marca;
      }

      if(res.Modelo !== undefined && res.Modelo !== null && res.Modelo !== "") {        
        setIsModeloPreenchido(true)
      }
      console.log(res.Modelo);
      if(getLanguage() === null) {
        if(res.Mercado !== "Nacional"){
          setLanguage('es');
          setIdioma('es');
        }else{
          setLanguage('pt');
          setIdioma('pt');
        }
    }

      if (res.objMLHeliarCertificadoGarantia != null && res.objMLHeliarCertificadoGarantia.Codigo > 0) {
        setCodigo(res.objMLHeliarCertificadoGarantia.Codigo);
        setValue("Codigo", res.objMLHeliarCertificadoGarantia.Codigo);

        setValue("ModeloBateria", res.objMLHeliarCertificadoGarantia.ModeloBateria);
        setValue("MarcaAnterior", res.objMLHeliarCertificadoGarantia.MarcaAnterior);
        setValue("NotaFiscal", res.objMLHeliarCertificadoGarantia.NotaFiscal);
        setValue("DataFiscal", (res.objMLHeliarCertificadoGarantia.DataFiscal == null ? "" : res.objMLHeliarCertificadoGarantia.DataFiscal).split('T')[0]);
        setValue("NumeroBateriaAnterior", res.objMLHeliarCertificadoGarantia.NumeroBateriaAnterior);
        setValue("DataSubstituicao", (res.objMLHeliarCertificadoGarantia.DataSubstituicao == null ? "" : res.objMLHeliarCertificadoGarantia.DataSubstituicao).split('T')[0]);
        setValue("ModeloVeiculo", res.objMLHeliarCertificadoGarantia.ModeloVeiculo);
        setValue("PlacaVeiculo", res.objMLHeliarCertificadoGarantia.PlacaVeiculo);
        setValue("NomeProprietario", "");
        setValue("EmailProprietario", "");
        setValue("NomeRevenda", res.objMLHeliarCertificadoGarantia.NomeRevenda);
        setValue("EstadoRevenda", res.objMLHeliarCertificadoGarantia.EstadoRevenda);

        if(res.objMLHeliarCertificadoGarantia.NumeroBateriaAnterior !== null) {
          setValue("SubstituicaoGarantia",'sim');
          setIsSubstituicao(true);
        }else {
          setValue("SubstituicaoGarantia",'nao');  
          setIsSubstituicao(false);
        }

        if(res.objMLHeliarCertificadoGarantia.CnpjRevenda !== null) {
          setValue("CnpjRevenda", res.objMLHeliarCertificadoGarantia.CnpjRevenda);
          localStorage.setItem("CNPJRevenda", res.objMLHeliarCertificadoGarantia.CnpjRevenda)
        }

        if(res.objMLHeliarCertificadoGarantia.EmailRevenda !== null) {
          setValue("EmailRevenda", res.objMLHeliarCertificadoGarantia.EmailRevenda);
          localStorage.setItem("EmailRevenda", res.objMLHeliarCertificadoGarantia.EmailRevenda)
        }

        //let estado = "uf=" + res.objMLHeliarCertificadoGarantia.EstadoRevenda + "&";
        /*getCidades(estado).then((cidades: any) => {
          setCidades(cidades);
        });
        setSelectedCidade(res.objMLHeliarCertificadoGarantia.CidadeRevenda);
      */
        setValue("TelefoneRevenda", res.objMLHeliarCertificadoGarantia.TelefoneRevenda);
        setValue("NomeInstalador", res.objMLHeliarCertificadoGarantia.NomeInstalador);
        setValue("EmailInstalador", res.objMLHeliarCertificadoGarantia.EmailInstalador);
        if(res.objMLHeliarCertificadoGarantia.TelefoneInstalador !== null) {
          //setMaskTelefone(res.objMLHeliarCertificadoGarantia.TelefoneInstalador.length > 14 ? "(99) 99999-9999" : "(99) 9999-9999");
          setValue("TelefoneInstalador", res.objMLHeliarCertificadoGarantia.TelefoneInstalador);
        }
        
      }
      else {
        getNumeroSerie(params).then((res: any) => {
          if (!res.sucesso) {
            setErroGrave(!res.sucesso);
            setSuccess(res.sucesso);
            //setErrorForm(res.erro);
            setErrorForm(getResource(res.chaveerro));
            setIsSemnumeroSerie(true);
             //setIsSemIdentidade(true)
             
            return;
          }
          else {
            setDataFabrticacao((res.dataFabricacao == null ? "0001-01-01T00:00:00" : res.dataFabricacao).split('T')[0]);
          }
        });
      }

      setConfig(res);
      
      if (!res.sucesso) {
        setErroGrave(false);
        setSuccess(res.sucesso);        
        //setErrorForm(res.erro);
        setErrorForm(getResource(res.chaveerro));
      }
      
    });

  }, []);

  const modeloBateria = watch("ModeloBateria")

  const debounce = (func: any, timeout = 300) => {
    let timer: any;
    return (...args: any[]) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }
  
  const debouncedGetVeiculos = useCallback(debounce(() => {
    const modeloBateria = `ModeloBateria=${getValues("ModeloBateria")}`
    
    getVeiculos(modeloBateria).then((res: any) => {
      setVeiculos(res);
    });
  }, 700), [])
  
  useEffect(() => {

    debouncedGetVeiculos()

  }, [modeloBateria])

  const handleChangeVeiculo = (event: any, value:any) => {
    console.log(value);
    if(value == 'OUTROS'){
      setisVeiculoOutros(true);
    }else{

      setisVeiculoOutros(false);
    }
  };
 const handleChangeIdioma = (lang: string) => {
    setLanguage(lang);
    
    setIdioma(lang);
    //getApiResources();
    window.location.reload(); // recarrega para aplicar o idioma em toda a página
  };
  const handleChangeSubstituicao = (obj: any) => {
    //console.log(obj);
    setIsSubstituicao(obj.target.value === "sim");
  };
  return (
    <FORMULARIO>
       <div style={{ display: "flex", justifyContent: "flex-end", padding: "10px" }}>
        <select
          value={idioma?? "pt"}
          onChange={e => handleChangeIdioma(e.target.value)}
          style={{ border: "none", background: "transparent", cursor: "pointer" }}
        >
          <option value="pt">
            🇧🇷 Português
          </option>
          <option value="es">
            🇪🇸 Español
          </option>
        </select>
      </div>
      <HeaderFormulario background={(id && !isSemnumeroSerie) ? config?.Cor: "#EDEDED"} logo={(id && !isSemnumeroSerie)  ? config?.Logo: clarioslogo} />
      <main className="certificado">
        <section className="container">
          <h2 className="certificado__title">
            {getResource("LBL_TITULO")}
          </h2>
          {!id &&
            <h3>A emissão do certificado deve ser feito através da leitura do QR-Code da Bateria</h3>
          }
          <FormProvider {...methods}>

            {(id && isSemIdentidade) && (
              <div ref={ref}
                className="msg-contato alert alert-danger">
                  Esta marca ainda não contém certificado digital.
              </div>
            )}
            {(isSemnumeroSerie) && (
              <div ref={ref}
                className="msg-contato alert alert-danger">
                  Número de série inválido.
              </div>
            )}
            {(id && !isSemIdentidade && !isSemnumeroSerie) && (
              <form id="formGarantia" onSubmit={handleSubmit(salvarGarantia)}>
              {
                <div ref={ref}
                  className={"msg-contato alert alert-" + (isSuccess ? "success" : "danger")}
                  style={{ display: isSuccess || isError != "" ? "block" : "none" }}>
                  {isError == "" &&
                    getResource("LBL_GARANTIA-GERADO-COM-SUCESSO")
                  }
                  {isError != "" &&
                    isError
                  }
                </div>
              }
              <div className="row">
                <div className="col-md-4 col-12" hidden>
                  <figure className="img-responsive"><img alt="Imagem de bateria automotiva" src="/portal/heliar/content/images/bateria.png" /></figure>
                </div>

                <div className="col-md-8 col-12" hidden>
                  <figure className="img-responsive qr-code"><img alt="QR code" src="/portal/heliar/content/images/qrcode.jpg" /></figure>
                </div>
                <div className="col-12">
                    <label className="certificado__subtitle" >{getResource("SEC_BATERIA")}</label>
                    <input {...register("Codigo")} type="hidden" />
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label className="certificado__label">{getResource("LBL_MODELO")} <span className='label__asterisco'>*</span></label>
                    <input {...register("ModeloBateria", { required: true })}
                      className={"form-control" + (errors.ModeloBateria ? " is-invalid" : "")} type="text" disabled={isModeloPreenchido || codigo > 0 || isErroGrave} />
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <label className="certificado__label" >{getResource("LBL_SERIE")} <span className='label__asterisco'>*</span></label>
                  <div className="form-group input-group certificado__input-copy">
                    <input {...register("SerieBateria", { required: true })}
                      className={"form-control" + (errors.SerieBateria ? " is-invalid" : "")} type="text" disabled={isNumeroSeriePreenchido || codigo > 0 || isErroGrave}/>
                    <div className="input-group-append" onClick={() => {navigator.clipboard.writeText(getValues("SerieBateria"))}}>
                      <span className="input-group-text icon icon-copy"></span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label className="certificado__label" >{getResource("LBL_NOTAFISCAL")}</label>
                    <input {...register("NotaFiscal")} className={"form-control" + (errors.NotaFiscal ? " is-invalid" : "")} type="text" disabled={codigo > 0 || isErroGrave} />
                  </div>
                </div>

                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label className="certificado__label" >{getResource("LBL_DATA")} <span className='label__asterisco'>*</span></label>
                    <input {...register("DataFiscal", { required: true })} className={"form-control" + (errors.DataFiscal ? " is-invalid" : "")} type="date" min={dataFabrticacao} max={dataAtual.toISOString().split('T')[0]} disabled={codigo > 0 || isErroGrave} />

                  </div>
                </div>

                 <div className="col-12">
                 <div className="form-group">
                  <label className="certificado__label">{getResource("LBL_TITULO_SUBSTITUICAO")}</label>
                  <div>
                    <label className='certificado__label' style={{ marginRight: "15px" }}>
                      <input
                        style={{ height: "20px", width: "20px" }}
                        disabled={codigo > 0 || isErroGrave}
                        type="radio"
                        value="sim"
                        {...register("SubstituicaoGarantia", { required: codigo <=0, onChange: (e) => { handleChangeSubstituicao(e); } })}
                      /> {getResource("LBL_SIM")}
                    </label>
                    <label className='certificado__label'>
                      <input 
                        style={{ height: "20px", width: "20px" }}
                        disabled={codigo > 0 || isErroGrave}
                        type="radio"
                        value="nao"
                        {...register("SubstituicaoGarantia", { required: codigo <=0, onChange: (e) => { handleChangeSubstituicao(e); } })}
                      /> {getResource("LBL_NAO")}
                    </label>
                  </div>
                  
                  {codigo <= 0 && errors.SubstituicaoGarantia && (
                    <small className="text-danger">{getResource("LBL_SELECIONE_OPCAO")}.</small>
                  )}
                </div>
                
                </div>
                  {isSubstituicao && 
                  <>
                    <div className="col-md-6 form-group">
                      <label className="certificado__label" >{getResource("LBL_NUMERO_SUBSTITUIDA")} <span className='label__asterisco'>*</span></label>
                      <input {...register("NumeroBateriaAnterior",{ required: true })} className={"form-control" + (errors.NumeroBateriaAnterior ? " is-invalid" : "")} type="text" disabled={codigo > 0 || isErroGrave} />
                    </div>
                
                    <div className="col-md-6 form-group">
                      <label className="certificado__label" >{getResource("LBL_DATA_SUBSITUICAO")} <span className='label__asterisco'>*</span></label>
                      <input {...register("DataSubstituicao",{ required: true })} className={"form-control" + (errors.DataSubstituicao ? " is-invalid" : "")} type="date" disabled={codigo > 0 || isErroGrave} />
                    </div>
                    </>
                 }
              
             
                <div className="col-12">
                  <p className="certificado__subtitle">
                    {getResource("SEC_VEICULO")}
                  </p>
                </div>
                <div className="col-md-12 col-12">
                  <div className="form-group">
                    <label className="certificado__label" >{getResource("LBL_VEICULO")} <span className='label__asterisco'>*</span></label>
                    {codigo > 0 || isErroGrave ?
                      <input autoComplete='nope' {...register("ModeloVeiculo")} type="text" className="form-control" disabled={codigo > 0 || isErroGrave} />
                      :
                      <Autocomplete
                        disablePortal
                        options={veiculos}
                        onChange={handleChangeVeiculo}
                        sx={{
                          borderRadius: "10px",
                          bgcolor: '#fff', '& input': {
                            height: 15,
                            bgcolor: '#fff',
                            color: (theme) =>
                              theme.palette.getContrastText(theme.palette.background.paper),
                          }
                        }}
                        renderInput={(params) => <TextField  {...register("ModeloVeiculo", { required: true })} sx={{ borderRadius: "10px", "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { borderColor: errors.ModeloVeiculo ? "red" :"#8C8C8C" }, "& .MuiOutlinedInput-notchedOutline": { borderColor: errors.ModeloVeiculo ? "red" :"#8C8C8C", borderRadius: "10px" }}}
                          {...params} label={getResource("LBL_PROCURE-SEU-VEICULO")} />}
                      />
                    }
                  </div>
                </div>
                    {isVeiculoOutros &&
                    <div className="col-md-12 col-12">
                    <div className="form-group">
                      <label className="certificado__label" >{getResource("LBL_DIGITE-NOME-VEICULO")} <span className='label__asterisco'>*</span></label>
                      <input {...register("VeiculoOutros", { required: true })} className={"form-control" + (errors.VeiculoOutros ? " is-invalid" : "")} type="text"  />
                    </div>
                  </div>
                    }
                <div className="col-12">
                  <p className="certificado__subtitle">
                     {getResource("SEC_PROPRIETARIO")}
                  </p>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label className="certificado__label" >{getResource("LBL_NOME")} <span className='label__asterisco'>*</span></label>
                    {codigo > 0 ?
                      <input autoComplete='nope' {...register("NomeProprietario", { required: true })} className={"form-control" + (errors.NomeProprietario ? " is-invalid" : "")} type="text" autoFocus disabled={isErroGrave} />
                      :
                      <input autoComplete='nope' {...register("NomeProprietario", { required: true })} className={"form-control" + (errors.NomeProprietario ? " is-invalid" : "")} type="text" disabled={isErroGrave} />
                    }
                  </div>
                </div>

                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label className="certificado__label" >{getResource("LBL_EMAIL")} <span className='label__asterisco'>*</span></label>
                    <input {...register("EmailProprietario", { required: true, pattern: /^\S+@\S+$/i })} className={"form-control" + (errors.EmailProprietario ? " is-invalid" : "")} type="email" disabled={isErroGrave} />
                  </div>
                </div>

                <div className="col-12">
                  <p className="certificado__subtitle">
                    {getResource("SEC_REVENDA")}
                  </p>
                </div>

                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label className="certificado__label" >{getResource("LBL_CNPJ")} <span className='label__asterisco'>*</span></label>
                     {idioma === "pt" ? (
                    <InputMask mask={"**.***.***/****-**"}
                      {...register("CnpjRevenda", { required: codigo <=0, value: localStorage.getItem("CnpjRevenda") !== null ? localStorage.getItem("CnpjRevenda") : "" })}
                      onBlur={() => {
                        localStorage.setItem("CnpjRevenda", getValues("CnpjRevenda"))
                      }}
                      className={"form-control" + (errors.CnpjRevenda ? " is-invalid" : "")} disabled={codigo > 0 || isErroGrave}
                    ></InputMask>
                    ) : (
                          <input {...register("CnpjRevenda", { required: codigo <=0, value: localStorage.getItem("CnpjRevenda") !== null ? localStorage.getItem("CnpjRevenda") : "" })}
                          onBlur={() => {
                            localStorage.setItem("CnpjRevenda", getValues("CnpjRevenda"))
                          }} className={"form-control" + (errors.CnpjRevenda ? " is-invalid" : "")} disabled={codigo > 0 || isErroGrave} />
                      )}
                  </div>
                </div>

                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label className="certificado__label" >{getResource("LBL_EMAIL-REV")} <span className='label__asterisco'>*</span></label>
                    <input {...register("EmailRevenda", { required: codigo <=0, pattern: /^\S+@\S+$/i, value: localStorage.getItem("EmailRevenda") !== null ? localStorage.getItem("EmailRevenda") : "" })} className={"form-control" + (errors.EmailRevenda ? " is-invalid" : "")} type="email" disabled={codigo > 0 || isErroGrave} onBlur={() => {
                        localStorage.setItem("EmailRevenda", getValues("EmailRevenda"))
                      }}/>
                  </div>
                </div>
                <div className="col-12">
                  <p className="certificado__subtitle">
                    {getResource("LBL_APLICADOR")} 
                  </p>
                </div>
                <div className="col-md-4 col-12">
                  <div className="form-group">
                    <label className="certificado__label" > {getResource("LBL_NOME")} </label>
                    <input {...register("NomeInstalador")} className={"form-control" + (errors.NomeInstalador ? " is-invalid" : "")} type="text" disabled={codigo > 0 || isErroGrave} />
                  </div>
                </div>
                <div className="col-md-5 col-12">
                  <div className="form-group">
                    <label className="certificado__label" > {getResource("LBL_CAMPANHA")} </label>
                    <input {...register("EmailInstalador")} className={"form-control" + (errors.EmailInstalador ? " is-invalid" : "")} type="text" disabled={codigo > 0 || isErroGrave} />
                  </div>
                </div>
                  <div className="col-md-3 col-12">
                  <div className="form-group">
                    <label className="certificado__label" > {getResource("LBL_TELEFONE")} </label>
                      {idioma === "pt" ? (
                        <InputMask
                              mask="(99) 99999-9999"
                              {...register("TelefoneInstalador")}
                              disabled={codigo > 0 || isErroGrave}
                              className={
                                "form-control" +
                                (errors.TelefoneInstalador ? " is-invalid" : "")
                              }
                            />
                      ) : (
                          <input {...register("TelefoneInstalador")} className={"form-control" + (errors.TelefoneInstalador ? " is-invalid" : "")} maxLength={20} type="number" disabled={codigo > 0 || isErroGrave} />
                      )}
                  
                  </div>
                </div>

                <div className="col-md-8 col-12">
                  <div className="form-group termos">
                    <label className='custom-checkbox'>
                      <input {...register("AceitoTermos", { required: true })} type="checkbox" value="2" className='checkbox'/>
                      <span className="checkmark"></span>
                      {getResource("LBL_TERMOS_1")} <a href={urlPrivacidade} target="_blank">{getResource("LBL_TERMOS_2")}</a>
                    </label>
                    <small className="w-100 invalid-feedback" id="msg-termo" style={{ display: (errors.AceitoTermos ? "block" : "none"), paddingLeft: "40px" }}>{getResource("LBL_VALIDAR-TERMOS")}</small>
                  </div>

                </div>
                <div className="col-md-4 col-12 campos">
                  <p>( <span style={{color: "#FF8F5F"}}>*</span> ) {getResource("LBL_CAMPOS-OBRIGATORIOS")}</p>
                </div>
                <div className='col-12 text-center'>
                <button disabled={isLoading || isErroGrave}
                    style={{ backgroundColor: config?.Cor === null ? "#1ed760" : config?.Cor }}
                    className="btn btn-landing"
                    id="btnSalvar" type="submit">
                    {
                      isLoading ? getResource("BTN_GERANDO-CERTIFICADOS") : getResource("BTN_GERAR-CERTIFICADOS")
                    }
                  </button>
                </div>
              </div>
            </form>
            )}
            {/*(!id) && (
              <form onSubmit={(e) => { e.preventDefault() }}>
              <div className="col-md-12 col-12">
                  <label className="certificado__label" >Série <span className='label__asterisco'>*</span></label>
                  <div className="form-group input-group">
                    <input {...register("SerieBateria", { required: true })}
                      className={"form-control" + (errors.SerieBateria ? " is-invalid" : "")} type="text"/>
                  </div>
              </div>
              <div className="col-md-12 col-12 campos">
                  <p>( <span style={{color: "#FF8F5F"}}>*</span> ) Campos obrigatórios</p>
                </div>
              <div className='col-12 text-center'>
              <button
                  style={{ backgroundColor: "#490E6F", color:"white" }}
                  className="btn btn-landing"
                  onClick={() => {
                    const SerieBateria = getValues("SerieBateria")
                    if(SerieBateria !== "") {
                      navigate("/" + SerieBateria);
                      location.reload()
                    }
                  }}>
                    Continuar
                </button>
              </div>
            </form>
            )*/}
            
          </FormProvider>
        </section>
      </main>
    </FORMULARIO>
  )
}
const FORMULARIO = styled.section`

`;
